import { useState, useCallback, useMemo } from "react";
import WebApp from "@twa-dev/sdk";
import { ProjectsPage } from "./pages/ProjectsPage";
import { CreateBotPage } from "./pages/CreateBotPage";
import { BotDetailPage } from "./pages/BotDetailPage";
import { useTelegram } from "./hooks/useTelegram";

export type Page = "projects" | "create" | "detail";

export function App() {
  const [page, setPage] = useState<Page>("projects");
  const [selectedBotId, setSelectedBotId] = useState("");
  const { user, cssVars } = useTelegram();

  const navigate = useCallback((p: Page, botId?: string) => {
    setPage(p);
    if (botId) setSelectedBotId(botId);
    WebApp.BackButton.offClick(backHandler);
    if (p !== "projects") {
      WebApp.BackButton.show();
      WebApp.BackButton.onClick(backHandler);
    } else {
      WebApp.BackButton.hide();
    }
  }, []);

  function backHandler() {
    setPage("projects");
    setSelectedBotId("");
    WebApp.BackButton.hide();
  }

  const currentPage = useMemo(() => {
    switch (page) {
      case "create":
        return <CreateBotPage user={user} onBack={() => navigate("projects")} onCreated={(id) => navigate("detail", id)} />;
      case "detail":
        return <BotDetailPage user={user} botId={selectedBotId} onBack={() => navigate("projects")} />;
      default:
        return <ProjectsPage user={user} onSelect={(id) => navigate("detail", id)} onCreate={() => navigate("create")} />;
    }
  }, [page, selectedBotId, user]);

  return (
    <div className="app" style={cssVars as React.CSSProperties}>
      <main className="app-main">
        {currentPage}
      </main>
    </div>
  );
}
